import { Observable } from 'rxjs';

export abstract class RegistrationConfirmationAdapter {
  abstract registrationConfirmation(token: string): Observable<void>;
}
